import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@auth/data-access';

/**
 * Allow authenticated users through; otherwise redirect to a local route
 * inside the same app (kiosk pattern). Unlike `DomainGuard`, this guard
 * does NOT leave the current app — useful for kiosk/tablet surfaces where
 * the operator should pair the device via a local sign-in screen instead
 * of being bounced to the accounts app.
 *
 * @example
 *   canActivate: [requireLoginGuard('/sign-in')]
 */
export function requireLoginGuard(redirectTo: string): CanActivateFn {
  return () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    return authStore.isLoggedIn() ? true : router.createUrlTree([redirectTo]);
  };
}
